export const actionTypes = {
    GET_TICKETS: 'GET_TICKETS',
    GET_USERINFO: 'GET_USERINFO',
}

export const initialState = {
    ticketList: false,
    userInfo: {}
}

export function reducer(state, action) {
    switch (action.type) {
        case actionTypes.GET_TICKETS:
            const { ticketList } = action.payload
            return {
                ...state,
                ticketList,
            }
        case actionTypes.GET_USERINFO:
            const { userInfo } = action.payload
            return {
                ...state,
                userInfo,
            }
        default:
            throw Error(`action type not allowed: ${action.type}`)
    }
}